import {  Component, OnInit } from '@angular/core';
import {  TranslationService } from '@spartacus/core';
import {CustomProductsService} from './custom-products.service';
import { CustomProductsFilterBarComponent } from './custom-products-filter-bar/custom-products-filter-bar.component';
import { CustomProductsContentComponent } from './custom-products-content/custom-products-content.component';
@Component({
    selector: 'app-custom-products',
    templateUrl: './custom-products.component.html',
    styleUrls: ['./custom-products.component.scss'],
    imports: [CustomProductsFilterBarComponent, CustomProductsContentComponent]
})
export class CustomProductsComponent implements OnInit {
  enableLoader = true;
  contacts: any;
  errorMessage: any;
  updatecontact: any;
  contactdetails = false;
  title: any;
  navigationData: string;
  addupdate = false;
  users: any;
  activeusers: any;
  token: any;
  products: any;
  loggedinUser: any;
  customerId: any;

  constructor(
              private translation: TranslationService,
              private customProductsService: CustomProductsService
              ) { }

  ngOnInit(): void {
    this.customProductsService.getHomeLinkActive(true);
    this.customProductsService.scrollToTop();
    this.translation.translate('breadcrumb.contacts.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.contacts.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
  }

}
